import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { withRouterProps } from '../utils/with-router-props'

const mapStateToProps = (state) => {
    return {
        trucks: state.trucks,
        installations: state.installations,
        adminInstallations: state.adminInstallations,
        account: state.account,
        adminAccounts: state.adminAccounts,
        adminUser: state.adminUser,
        adminTemplates: state.adminInputTemplates,
        adminTemplateGroups: state.adminTemplateGroups,
        adminQuestions: state.adminQuestions,
        adminManuals: state.manuals
    }
}

const Breadcrumb = ({ crumbs, account, installations, adminInstallations, adminUser, adminAccounts, trucks, adminTemplates, adminTemplateGroups, adminQuestions, adminManuals }) => {
    let links = null
    if (crumbs && crumbs.length > 1) {
        links = crumbs.map((c, idx, arr) => {
            if (idx + 1 === arr.length) {
                // Dont show the last item / current page as its redundant
                return null
            }

            let entityType = null
            let entityId = null
            let entity = null

            // Extract entity info for view/dashboard/details routes
            if (c.label && (c.label.includes('View') || c.label.includes('Dashboard') || c.label.includes('Details'))) {
                // Look for numeric ID in the path segments
                const numericSegment = c.pathSegments?.find(segment => !isNaN(segment) && segment !== '')
                if (numericSegment) {
                    entityId = Number(numericSegment)

                    // Derive entity type from route key using switch cases
                    if (c.routeKey) {
                        if (c.routeKey.includes('Account') && !c.routeKey.includes('Users')) {
                            entityType = 'adminAccount'
                        } else if (c.routeKey.includes('Users') || c.routeKey.includes('User')) {
                            entityType = 'adminUser'
                        } else if (c.routeKey.includes('Installation')) {
                            entityType = 'adminInstallation'
                        } else if (c.routeKey.includes('Template') && !c.routeKey.includes('Group')) {
                            entityType = 'adminTemplate'
                        } else if (c.routeKey.includes('TemplateGroup') || c.routeKey.includes('Group')) {
                            entityType = 'adminTemplateGroup'
                        } else if (c.routeKey.includes('Question')) {
                            entityType = 'adminQuestion'
                        } else if (c.routeKey.includes('Manual')) {
                            entityType = 'adminManual'
                        } else if (c.routeKey.includes('Truck')) {
                            entityType = 'truck'
                        }
                    }
                }
            }

            // If we have entity info, find the entity using existing switch cases
            if (entityType && entityId) {
                switch (entityType) {
                case 'truck':
                    entity = trucks.find(t => t.id === entityId)
                    break
                case 'account':
                    entity = account && account.id === entityId ? account : null
                    break
                case 'installation':
                    entity = installations.find(t => t.id === entityId)
                    break
                case 'adminInstallation':
                    entity = adminInstallations.find(t => t.id === entityId)
                    break
                case 'adminUser':
                    entity = adminUser.find(t => t.id === entityId)
                    break
                case 'adminAccount':
                    entity = adminAccounts.find(t => t.id === entityId)
                    break
                case 'adminTemplate':
                    entity = adminTemplates.find(t => t.id === entityId)
                    break
                case 'adminTemplateGroup':
                    entity = adminTemplateGroups.find(t => t.id === entityId)
                    break
                case 'adminQuestion':
                    entity = adminQuestions.find(t => t.id === entityId)
                    break
                case 'adminManual':
                    entity = adminManuals.find(t => t.id === entityId)
                    break
                default:
                    entity = null
                }

                if (entity) {
                    // NOTE: Vendors use 'name' not sure if we want to change that
                    c.label = entity.label ? entity.label : entity.name
                }
            }

            // Handle legacy entityType/entityId if they exist directly on the crumb
            if (c.entityType && c.entityId && !entity) {
                switch (c.entityType) {
                case 'truck':
                    entity = trucks.find(t => t.id === c.entityId)
                    break
                case 'account':
                    entity = account && account.id === c.entityId ? account : null
                    break
                case 'installation':
                    entity = installations.find(t => t.id === c.entityId)
                    break
                case 'adminInstallation':
                    entity = adminInstallations.find(t => t.id === c.entityId)
                    break
                case 'adminUser':
                    entity = adminUser.find(t => t.id === c.entityId)
                    break
                case 'adminAccount':
                    entity = adminAccounts.find(t => t.id === c.entityId)
                    break
                case 'adminTemplate':
                    entity = adminTemplates.find(t => t.id === c.entityId)
                    break
                case 'adminTemplateGroup':
                    entity = adminTemplateGroups.find(t => t.id === c.entityId)
                    break
                case 'adminQuestion':
                    entity = adminQuestions.find(t => t.id === c.entityId)
                    break
                case 'adminManual':
                    entity = adminManuals.find(t => t.id === c.entityId)
                    break
                default:
                    entity = null
                }

                if (entity) {
                    // NOTE: Vendors use 'name' not sure if we want to change that
                    c.label = entity.label ? entity.label : entity.name
                }
            }

            return (
                <Link key={idx} to={c.path}>
                    {c.label}
                </Link>
            )
        })
    }
    // NOTE: Return wrapper even if empty to maintain DOM spacing
    return (
        <div id="breadcrumb">
            <div className="container">
                { links }
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(Breadcrumb))
